<template>
  <div class="d-flex align-center">
    <SoAvatar
      ref="meter-fuel"
      :type="isElectricity ? 'electric' : 'gas'"
      class="mr-2"
    />
    <h5 data-testid="meter-id" class="break-word">
      {{ meterpoint.meterpointType
      }}<template v-if="meterpoint.isExport"> - EXPORT</template> -
      {{ meterpoint.identifier }}
    </h5>
  </div>
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"
  import SoAvatar from "@/components/SoAvatar.vue"
  export interface MeterpointHeaderSummary {
    meterpointType: string
    identifier: string
    isExport?: boolean
  }
  export default defineComponent({
    components: { SoAvatar },
    props: {
      meterpoint: {
        type: Object as PropType<MeterpointHeaderSummary>,
        required: true,
      },
    },
    computed: {
      isElectricity() {
        return this.meterpoint.meterpointType === "MPAN"
      },
    },
  })
</script>
